//FOR FULL URL

// import CryptoJS from "crypto-js";

// // Put this in .env (VITE_URL_SECRET or REACT_APP_URL_SECRET, depending on your bundler)
// const SECRET: string =
//   (import.meta as any).env?.VITE_URL_SECRET ||
//   (process.env as any).REACT_APP_URL_SECRET ||
//   "change-me-url-secret";

// const KEY = CryptoJS.SHA256(SECRET); // 32-byte key => AES-256

// const toBase64Url = (b64: string) =>
//   b64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");

// const fromBase64Url = (s: string) => {
//   const b64 = s.replace(/-/g, "+").replace(/_/g, "/");
//   return b64 + "=".repeat((4 - (b64.length % 4)) % 4);
// };

// /** "/STUDENT/MSR/Profile?id=5#top" -> url-safe token */
// export function encryptUrl(plain: string): string {
//   const iv = CryptoJS.lib.WordArray.random(16);
//   const encrypted = CryptoJS.AES.encrypt(plain, KEY, {
//     iv,
//     mode: CryptoJS.mode.CBC,
//     padding: CryptoJS.pad.Pkcs7,
//   });
//   const combined = iv.clone().concat(encrypted.ciphertext);
//   return toBase64Url(CryptoJS.enc.Base64.stringify(combined));
// }

// /** token -> plain url, or null if invalid / tampered */
// export function decryptUrl(token: string): string | null {
//   try {
//     const all = CryptoJS.enc.Base64.parse(fromBase64Url(token));
//     const iv = CryptoJS.lib.WordArray.create(all.words.slice(0, 4), 16);
//     const ciphertext = CryptoJS.lib.WordArray.create(
//       all.words.slice(4),
//       all.sigBytes - 16
//     );
//     const decrypted = CryptoJS.AES.decrypt(
//       { ciphertext } as CryptoJS.lib.CipherParams,
//       KEY,
//       { iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
//     );
//     const plain = decrypted.toString(CryptoJS.enc.Utf8);
//     return plain.startsWith("/") ? plain : null;
//   } catch {
//     return null;
//   }
// }


// FOR ONLY QUERY PARAMS

import CryptoJS from "crypto-js";

// Put this in .env (VITE_URL_SECRET or REACT_APP_URL_SECRET, depending on your bundler)
const SECRET: string =
  (import.meta as any).env?.VITE_URL_SECRET ||
  (process.env as any).REACT_APP_URL_SECRET ||
  "change-me-url-secret";

const KEY = CryptoJS.SHA256(SECRET); // 32-byte key => AES-256

const toBase64Url = (b64: string) =>
  b64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");

const fromBase64Url = (s: string) => {
  const b64 = s.replace(/-/g, "+").replace(/_/g, "/");
  return b64 + "=".repeat((4 - (b64.length % 4)) % 4);
};

/** plain string -> url-safe token */
export function encryptUrl(plain: string): string {
  const iv = CryptoJS.lib.WordArray.random(16);
  const encrypted = CryptoJS.AES.encrypt(plain, KEY, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  const combined = iv.clone().concat(encrypted.ciphertext);
  return toBase64Url(CryptoJS.enc.Base64.stringify(combined));
}

/** token -> plain string, or null if invalid / tampered */
export function decryptUrl(token: string): string | null {
  try {
    const all = CryptoJS.enc.Base64.parse(fromBase64Url(token));
    const iv = CryptoJS.lib.WordArray.create(all.words.slice(0, 4), 16);
    const ciphertext = CryptoJS.lib.WordArray.create(
      all.words.slice(4),
      all.sigBytes - 16
    );
    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext } as CryptoJS.lib.CipherParams,
      KEY,
      { iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
    );
    const plain = decrypted.toString(CryptoJS.enc.Utf8);
    return plain || null;
  } catch {
    return null;
  }
}